import type { IProductInfoViewModel } from "../../network/contracts/IGenericIndexViewModel";
import { computed } from "mobx";
import { ICurrentEnvironmentStore } from "../environments/CurrentEnvironmentStore";

export interface IProductInfoStore {
    readonly version: string;
    readonly productReleaseDate: string;
    readonly manualsRevisionDate: string;
    readonly environmentMachineName: string;
    readonly softwareIdentificationNumber: string;
    isMedicalDevice: boolean;
}

export class ProductInfoStore implements IProductInfoStore {
    version = "";
    productReleaseDate = "";
    manualsRevisionDate = "";
    environmentMachineName = "";
    softwareIdentificationNumber = "";

    constructor(private readonly productInfoViewModel: IProductInfoViewModel, private readonly currentEnvironmentStore: ICurrentEnvironmentStore) {
        this.version = productInfoViewModel.version;
        this.productReleaseDate = productInfoViewModel.productReleaseDate;
        this.manualsRevisionDate = productInfoViewModel.manualsRevisionDate;
        this.environmentMachineName = productInfoViewModel.environmentMachineName;
        this.softwareIdentificationNumber = productInfoViewModel.softwareIdentificationNumber;
    }

    @computed
    public get isMedicalDevice() {
        const { currentEnvironment, countryIsMedicalDevice } = this.currentEnvironmentStore;
        //both should be true
        return (currentEnvironment?.medicalDevice ?? true) && countryIsMedicalDevice;
    }
}
